import "./Report.css";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import SideNav from "../SideNav/SideNav";
import { Button } from "react-bootstrap";
import CostBetaFullChart from "./Widgets/CostBetaFullChart";
import CostPDFFullChart from "./Widgets/CostPDFFullChart";
import CCSCostFullChart from "./Widgets/CCSCostFullChart";
import { useEffect, useState } from "react";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import CCECostMedianDesignChart from "./Widgets/CCECostMedianDesignChart";
import IRIMedianChart from "./Widgets/IRIMedianChart";

const CostDetailedReport = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    const [experiment, setExperiment] = useState({});
    const [design1Cost, setDesign1Cost] = useState([]);
    const [design2Cost, setDesign2Cost] = useState([]);
    const [design1Median, setDesign1Median] = useState([]);
    const [design2Median, setDesign2Median] = useState([]);
    const [design1IRIMedian, setDesign1IRIMedian] = useState([]);
    const [design2IRIMedian, setDesign2IRIMedian] = useState([]);
    const [design1MedianMax, setDesign1MedianMax] = useState(8);
    const [design2MedianMax, setDesign2MedianMax] = useState(8);

    useEffect(() => {
    axios.get(`${config.apiUrl}/api/experiment/${id}`)
        .then((response) => {
        setExperiment(response.data);
        })
        .catch((error) => {
            console.error("Error fetching data:", error);
        });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/design1-cost/${id}`)
            .then((response) => {
                setDesign1Cost(response.data.design1_cost);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/design2-cost/${id}`)
            .then((response) => {
                setDesign2Cost(response.data.design2_cost);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);


    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/design1-cost-median/${id}`)
            .then((response) => {
                setDesign1Median(response.data.design1_cost_median);
                const Cost1Total = response.data.design1_cost_median.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6);
                const yAxisMax = Math.ceil(Math.max(...Cost1Total));
                setDesign1MedianMax(yAxisMax);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/design2-cost-median/${id}`)
            .then((response) => {
                setDesign2Median(response.data.design2_cost_median);
                const Cost2Total = response.data.design2_cost_median.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6);
                const yAxisMax = Math.ceil(Math.max(...Cost2Total));
                setDesign2MedianMax(yAxisMax);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);

    // IRI data
    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/iri-design1-median/${id}`)
            .then((response) => {
                setDesign1IRIMedian(response.data.iri_design1_median); // Assuming your API returns the correct field
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);

    useEffect(() => {
        axios.get(`${config.apiUrl}/api/report/data/iri-design2-median/${id}`)
            .then((response) => {
                setDesign2IRIMedian(response.data.iri_design2_median); // Assuming your API returns the correct field
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, [id]);

    useEffect(() => {
    }, [design1Cost, design2Cost, design1Median, design2Median, design1IRIMedian, design2IRIMedian]);

    const analysisPeriod = 50;

    const goToBasicContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-basic/${id}`);
        }, 100);
    }

    const goToDetailedContext = () => {
        setTimeout(() => {
            navigate(`/pavement-context-custom/${id}`);
        }, 100);
    }

    const goToPedegreeMatrix = () => {
        setTimeout(() => {
            navigate(`/pedegree-matrix/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToConcreteEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/concrete-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToAsphaltEmbodiedEmission = () => {
        setTimeout(() => {
            navigate(`/asphalt-embodied-emission/${id}?backref=pavement-design`);
        }, 100);
    }

    const goToPavementDesign = () => {
        setTimeout(() => {
            navigate(`/pavement-design/${id}?backref=result`);
        }, 100);
    }

    return (
        <div className="rep__container">
            <SideNav id={id} passed={["pavement-context-basic", "pavement-context-custom", "pedegree-matrix", "pavement-design", "concrete-embodied-emission", "asphalt-embodied-emission"]}
                goToBasicContext={goToBasicContext}
                goToDetailedContext={goToDetailedContext}
                goToAsphaltEmbodiedEmission={goToAsphaltEmbodiedEmission}
                goToConcreteEmbodiedEmission={goToConcreteEmbodiedEmission}
                goToPedegreeMatrix={goToPedegreeMatrix}
                goToPavementDesign={goToPavementDesign}
                goToResults={() => { }}
            />
            <div className="rep__table">
                <Row>
                    <Col>
                        <CCECostMedianDesignChart
                            designCostMedian={design1Median}
                            analysisPeriod={analysisPeriod}
                            variant="1"
                            title={experiment?.design1?.title}
                            max={Math.max(design1MedianMax, design2MedianMax)}
                        />
                    </Col>
                    <Col>
                        <CCECostMedianDesignChart
                            designCostMedian={design2Median}
                            analysisPeriod={analysisPeriod}
                            variant="2"
                            title={experiment?.design2?.title}
                            max={Math.max(design1MedianMax, design2MedianMax)}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <CCSCostFullChart
                            design1Cost={design1Cost}
                            design2Cost={design2Cost}
                            design1title={experiment?.design1?.title}
                            design2title={experiment?.design2?.title}
                        />
                    </Col>
                    <Col>
                        <IRIMedianChart
                            IRI_design1_US={design1IRIMedian}
                            IRI_design2_US={design2IRIMedian}
                            analysisPeriod={analysisPeriod}
                            design1title={experiment?.design1?.title}
                            design2title={experiment?.design2?.title}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <CostBetaFullChart
                            design1Cost={design1Cost}
                            design2Cost={design2Cost}
                            design1title={experiment?.design1?.title}
                            design2title={experiment?.design2?.title}
                        />
                    </Col>
                    <Col>
                        <CostPDFFullChart
                            design1Cost={design1Cost}
                            design2Cost={design2Cost}
                            design1title={experiment?.design1?.title}
                            design2title={experiment?.design2?.title}
                        />
                    </Col>
                </Row>
            </div>

            <div className="pcb__box-footer">
                <Button variant="primary" href={`/report/${id}`}>Basic Report</Button>
            </div>
        </div>
    );
};

export default CostDetailedReport;